// Copyright (c) 2016 Deere & Company

import './dealer-percentage-item.scss';
import React, {PropTypes} from 'react';
import DealerPercentage from '@deere/cps-it.warranty-model-factory/lib/dealer-percentage';
import {buildClassName} from '../../../shared/services/build-class-name';
import {buildNumber} from '../../../../shared/services/build-number';

const DealerPercentageItem = props =>
    <li className='dealer-percentage-item'>
        <div className='row'>
            <div className='dealership'>
                {props.dealerPercentage.account}
            </div>
            <div className='percentage'>
                {`${buildNumber(props.dealerPercentage.completePercentage)}%`}
            </div>
            <div className='status-indicator'>
                <span className={buildClassName(props.targetCompletion, props.dealerPercentage.completePercentage)}/>
            </div>
        </div>
    </li>;

DealerPercentageItem.displayName = 'DealerPercentageItem';
DealerPercentageItem.propTypes = {
    dealerPercentage: PropTypes.instanceOf(DealerPercentage).isRequired,
    targetCompletion: PropTypes.number.isRequired
};

export default DealerPercentageItem;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-summary/dealer-percentage-item.js